import fetch from './../fetch';
import utils from './../../utils';


const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const querySearchAllTargetAndSubItem = () => {
    return fetch.get('zyzgtarget/allTargetAndSub')
    .then(response => response.payload.data)
    .then(result => {
        const data = transform(utils.fileTree(result));
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

const queryCharts = (data) => {
    return fetch.post('zyzg/eval/result/analysis/group/analysis', data)
    .then(res => {
        if(res.code === 200) {
            return {
                dataSource: res.payload.data,
            }
        }
        return {
            dataSource:[],
        }
    })
}

export default {
    querySearchAllTargetAndSubItem,
    queryCharts
}